export const QUERY_DEFAULT_VALUE = '';
export const REMOVED_ALL_CATEGORIES_VALUE = 'none';
